import React, { FC, ComponentProps } from 'react';
import styled from 'styled-components';

import { TableDeprecated } from '../TableDeprecated';
import { PaginationDeprecated } from '../PaginationDeprecated';

type PaginatedTableDeprecatedProps =  ComponentProps<typeof PaginationDeprecated> & ComponentProps<typeof TableDeprecated>; // prettier-ignore

export const PaginatedTableDeprecated: FC<PaginatedTableDeprecatedProps> = ({
  isLoading,
  currentPageNumber,
  currentPageSize: pageSize,
  totalItems,
  onChange: getPageData,
  testId,
  ...restProps
}) => (
  <PaginatedTableWrapper>
    <MarginWrapper>
      <TableDeprecated isLoading={isLoading} testId={testId} {...restProps} />
    </MarginWrapper>
    <PaginationDeprecated
      currentPageNumber={currentPageNumber}
      currentPageSize={pageSize}
      isLoading={isLoading}
      totalItems={totalItems}
      onChange={getPageData}
      testId={testId}
    />
  </PaginatedTableWrapper>
);

const PaginatedTableWrapper = styled.section``;

const MarginWrapper = styled.div`
  margin-bottom: 1.25em; /* TODO: theme */
`;
